import React from 'react';
import { Paper, Box, Avatar, Typography, Divider, Tooltip } from '@mui/material';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';

export const SectionCard = ({ icon, title, subtitle, error, children, sx, action }) => (
  <Paper
    elevation={0}
    sx={{
      p: 'clamp(12px, 1.4vw, 18px)',
      borderRadius: '16px',
      border: '1px solid',
      borderColor: error ? '#fca5a5' : '#e2e8f0',
      background: '#ffffff',
      boxShadow: '0 4px 20px rgba(15, 23, 42, 0.03)',
      transition: 'all 0.2s ease',
      '&:hover': {
        boxShadow: '0 10px 25px -5px rgba(15, 23, 42, 0.06)',
        borderColor: error ? '#f87171' : '#cbd5e1',
      },
      ...sx
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 'clamp(8px, 1vw, 12px)' }}>
      <Avatar
        sx={{
          width: 'clamp(28px, 2.2vw, 34px)',
          height: 'clamp(28px, 2.2vw, 34px)',
          bgcolor: '#eff6ff',
          color: '#0655A5',
          borderRadius: '10px',
          border: '1px solid #bfdbfe',
          '& .MuiSvgIcon-root': {
            fontSize: 'clamp(16px, 1.2vw, 19px)'
          }
        }}
      >
        {icon}
      </Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontWeight: 800,
            lineHeight: 1.15,
            fontSize: 'clamp(0.84rem, 0.8rem + 0.15vw, 0.94rem)',
            color: '#0f172a'
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            sx={{
              display: 'block',
              mt: 0.15,
              color: '#64748b',
              fontSize: 'clamp(0.68rem, 0.65rem + 0.08vw, 0.74rem)',
              fontWeight: 500
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {action && action}
        {error && (
          <Tooltip title={typeof error === 'string' ? error : 'Revisa los campos de esta sección'} arrow>
            <ErrorOutlineRoundedIcon color="error" sx={{ fontSize: 'clamp(16px, 1.2vw, 20px)' }} />
          </Tooltip>
        )}
      </Box>
    </Box>
    <Divider sx={{ my: 'clamp(10px, 1.2vw, 14px)', borderColor: '#f1f5f9' }} />
    {children}
  </Paper>
);

export const elegantInputSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    backgroundColor: '#ffffff',
    fontSize: 'clamp(0.78rem, 0.74rem + 0.1vw, 0.86rem)',
    transition: 'all 0.15s ease',
    '& fieldset': { borderColor: '#cbd5e1' },
    '&:hover fieldset': { borderColor: '#94a3b8' },
    '&.Mui-focused fieldset': { borderColor: '#0655A5', borderWidth: '1.5px' },
    '&.Mui-focused': { boxShadow: '0 0 0 3px rgba(6,85,165,0.12)', backgroundColor: '#ffffff' },
  },
  '& .MuiInputLabel-root': {
    fontWeight: 650,
    fontSize: 'clamp(0.76rem, 0.72rem + 0.1vw, 0.84rem)',
    color: '#64748b',
    '&.Mui-focused': { color: '#0655A5' }
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0.5,
    fontSize: 'clamp(0.64rem, 0.62rem + 0.05vw, 0.70rem)',
    fontWeight: 600
  }
};

export const bytesToSize = (bytes = 0) => {
  if (bytes === 0) return '0 B';
  const k = 1024, sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};
